export default __webpack_public_path__ + "static/media/client-6.eb0a816f.png";